<script>
    import Icon from '$component/Icon.svelte';
    // Order remark (oxorder.OXREMARK) — an unobtrusive "Mitteilung hinzufügen"
    // link in the basket step. Collapsed by default to a single header link;
    // clicking it reveals a textarea. Once a remark is saved it stays expanded
    // across reloads (hydrated from basketStore.orderRemark).
    //
    // Persistence: the textarea saves debounced on-input (~500ms) and flushed
    // on blur via saveOrderRemark → POST m7-checkout-doc/saveOrderRemark, which
    // writes the PHP session var `ordrem`.

    import {store as basketStore, saveOrderRemark} from '$lib/basketStore.svelte.js';
    import {t} from '$utils/lang.js';

    // Local editing state. Hydrated ONCE from the store so a background basket
    // refresh (add/remove item, recalc) never clobbers what the user is typing.
    let remark = $state('');
    let hydrated = $state(false);
    let expanded = $state(false);

    $effect(() => {
        if (hydrated) return;
        // Wait until the store value is defined (first basket load can be async).
        const initial = basketStore.orderRemark;
        if (initial === undefined || initial === null) return;
        remark = initial;
        // Keep it expanded when there's already a saved remark (persist UX),
        // otherwise stay collapsed and unobtrusive.
        if (initial.trim() !== '') expanded = true;
        hydrated = true;
    });

    let debounceTimer;
    function scheduleSave() {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => saveOrderRemark(remark), 500);
    }
    function flushSave() {
        clearTimeout(debounceTimer);
        saveOrderRemark(remark);
    }

    function toggle() {
        expanded = !expanded;
    }
</script>

<div
    class="bg-white rounded-md border border-grey shadow-sm"
    data-checkout-section="order-remark"
    data-checkout-state={expanded ? 'expanded' : 'collapsed'}
>
    <button
        type="button"
        onclick={toggle}
        data-checkout-action="toggle-order-remark"
        aria-expanded={expanded}
        class="flex w-full items-center justify-between gap-2 px-5 py-3.5 text-left text-sm font-semibold text-cyprus hover:text-elm transition-colors cursor-pointer"
    >
        <span>{t('Mitteilung hinzufügen')}</span>
        <Icon name="down" class={"h-4 w-4 shrink-0 transition-transform duration-200 " + (expanded ? "rotate-180" : "")}/>
    </button>

    {#if expanded}
        <div class="px-5 pb-4">
            <textarea
                bind:value={remark}
                oninput={scheduleSave}
                onblur={flushSave}
                placeholder={t('Hier kannst du uns noch etwas mitteilen.')}
                rows="3"
                data-checkout-input="order-remark"
                class="w-full rounded-md border border-grey p-3 text-sm text-cyprus placeholder:text-gray-400 focus:border-cyprus focus:outline-none resize-y"
            ></textarea>
        </div>
    {/if}
</div>
